import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
var PaymentStatusService = /** @class */ (function () {
    function PaymentStatusService(http) {
        this.http = http;
        this.server = environment.server;
        this.getQrUpiDataURL = this.server + '/api/payments/getQrUpiData';
    }
    PaymentStatusService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    PaymentStatusService.prototype.getQrUpiData = function (reqBody) {
        return this.http.post(this.getQrUpiDataURL, reqBody).pipe(catchError(this.handleError));
    };
    PaymentStatusService.ngInjectableDef = i0.defineInjectable({ factory: function PaymentStatusService_Factory() { return new PaymentStatusService(i0.inject(i1.MyHttpClient)); }, token: PaymentStatusService, providedIn: "root" });
    return PaymentStatusService;
}());
export { PaymentStatusService };
